import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ConstructionIcon from "@mui/icons-material/Construction";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";

const ComingSoonPage = ({ title = "Feature", description, features = [] }) => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 4 }}>
      <Paper
        elevation={3}
        sx={{
          p: 6,
          textAlign: "center",
          background:
            "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            display: "inline-flex",
            p: 3,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #1A5EA8 0%, #0B2545 100%)",
            mb: 3,
          }}
        >
          <ConstructionIcon sx={{ fontSize: 60, color: "white" }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h3"
          fontWeight="bold"
          gutterBottom
          sx={{
            background: "linear-gradient(135deg, #1A5EA8 0%, #0B2545 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {title}
        </Typography>

        <Typography variant="h5" color="text.secondary" sx={{ mb: 1 }}>
          Coming Soon
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4, maxWidth: 600, mx: "auto" }}
        >
          {description ||
            `We're working hard to bring you this feature. Stay tuned for updates!`}
        </Typography>

        {/* Features List (if provided) */}
        {features && features.length > 0 && (
          <Card
            elevation={2}
            sx={{ mb: 4, textAlign: "left", maxWidth: 600, mx: "auto" }}
          >
            <CardContent>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                What to Expect:
              </Typography>
              <Box component="ul" sx={{ pl: 3, mb: 0 }}>
                {features.map((feature, index) => (
                  <Typography
                    component="li"
                    key={index}
                    variant="body2"
                    sx={{ mb: 1 }}
                  >
                    {feature}
                  </Typography>
                ))}
              </Box>
            </CardContent>
          </Card>
        )}

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Button
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{
              background: "linear-gradient(135deg, #1A5EA8 0%, #0B2545 100%)",
              "&:hover": {
                background: "linear-gradient(135deg, #5568d3 0%, #653a8b 100%)",
              },
            }}
          >
            Go Back
          </Button>
          <Button
            variant="outlined"
            startIcon={<HomeIcon />}
            onClick={() => navigate("/dashboard")}
            sx={{
              borderColor: "#1A5EA8",
              color: "#1A5EA8",
              "&:hover": {
                borderColor: "#5568d3",
                bgcolor: "rgba(102, 126, 234, 0.08)",
              },
            }}
          >
            Go to Dashboard
          </Button>
        </Box>

        {/* Footer Note */}
        <Box
          sx={{ mt: 4, pt: 3, borderTop: "1px solid", borderColor: "divider" }}
        >
          <Typography variant="caption" color="text.secondary">
            Have feedback or suggestions? Contact us at{" "}
            <Box component="span" sx={{ color: "#1A5EA8", fontWeight: 600 }}>
              support@nephrotrax.com (or sandeep.sinha@verainsight.com)
            </Box>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default ComingSoonPage;
